import { default as getCookie } from "@pb/utils/getCookie";
import constants from '../../constants';
const getBpidFromCustomCookie = () => {
    const cookieObject = getCookie(constants.COOKIE_NAME);
    if (cookieObject) {
        const dataInJSON = JSON.parse(cookieObject);
        if (dataInJSON === null || dataInJSON === void 0 ? void 0 : dataInJSON.bpid) {
            return dataInJSON === null || dataInJSON === void 0 ? void 0 : dataInJSON.bpid;
        }
    }
    return '';
};
export default getBpidFromCustomCookie;
//# sourceMappingURL=getBpidFromCustomCookie.js.map